import { SxProps } from '@mui/material/styles';

const CONTENT_GREEN = '#1e4620';
const CONTENT_RED = '#621b16';
const ARROW_GREEN = '#2d8630';
const ARROW_RED = '#e91607';

export const container: SxProps = {
  display: 'flex',
  marginTop: '18px',
  justifyContent: 'center',
  alignItems: 'center',
};

export function getChipStyles(isImprovement: boolean, isNoChange = false) {
  const styles: SxProps = {
    fontWeight: '500',
    marginRight: '6px',
  };
  if (!isNoChange) {
    styles.color = isImprovement ? CONTENT_GREEN : CONTENT_RED;
  }

  return styles;
}

export function getArrowStyles(isImprovement: boolean) {
  return {
    color: isImprovement ? ARROW_GREEN : ARROW_RED,
    marginRight: '4px',
  };
}

export const label: SxProps = {
  fontSize: '14px',
  letterSpacing: '0px',
  fontWeight: '500',
};
